import React, { Component, PropTypes } from 'react';
import IndeedConversionCode from '../IndeedConversionCode';
import { template } from 'lodash';

export default class isDupAndUnqualified extends Component {

  static propTypes = {
    message: PropTypes.string,
  }

  constructor(props) {
    super(props);
  }

  render() {
    const {
      message,
    } = this.props;
    const html = template(message)(this.props);

    return (
    <div className='rejection-body message-body'>
      <IndeedConversionCode conversionLabel='duplicate and unquailified'/>
      <div dangerouslySetInnerHTML={{__html: html}}></div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/f_DuplicateAndUnqualified/index.js